export default {
    name: 'StyleGuidePage',
    data() {
        return {
            roomName: 'Guestroom 102',
            password: '',
            passwordConfirm: '',
            checkPassword: '',
            showPasswordHint: false,
            rules: [
                {
                    show: true,
                    icon: 'check',
                    color: 'gray-10',
                    specialCharacters: false,
                    valid: false,
                    message: 'Minimum of 9 characters',
                    regex: /.{9,}/
                },
                {
                    show: true,
                    icon: 'check',
                    color: 'gray-10',
                    specialCharacters: false,
                    valid: false,
                    message: 'At least 1 uppercase letter',
                    regex: /[A-Z]+/
                },
                {
                    show: true,
                    icon: 'check',
                    color: 'gray-10',
                    specialCharacters: false,
                    valid: false,
                    message: 'At least 1 lowercase letter',
                    regex: /[a-z]+/
                },
                {
                    show: true,
                    icon: 'check',
                    color: 'gray-10',
                    specialCharacters: false,
                    valid: false,
                    message: 'One number required.',
                    regex: /[0-9]+/
                },
                {
                    show: false,
                    icon: 'times',
                    color: 'red-30',
                    specialCharacters: true,
                    valid: true,
                    message:
                        'Allowed special characters: ! # $ % & * - < = > ? @ _ | ~',
                    regex: /^[A-Za-z0-9!#$%&?@_|~<=>*-]+$/
                }
            ],
            showConfirmHint: false,
            testInput: '',
            testPassword: '',
            testTextarea: '',
            testRadio: '',
            testCheckbox: false,
            selectAll: false,
            testCheckboxArr: [],
            testTogglePassword: '',
            testInputType: 'is-normal',
            testTextareaType: 'is-normal',
            testPasswordType: 'is-normal',
            testPasswordStatus: 'is-normal',
            activePopover: false,
            fieldCriteria: [
                {
                    id: 1,
                    icon: 'check',
                    status: 'text',
                    text: 'At least 8 characters'
                },
                {
                    id: 2,
                    icon: 'check',
                    status: 'text',
                    text: 'At least 1 uppercase letter'
                },
                {
                    id: 3,
                    icon: 'check',
                    status: 'text',
                    text: 'At least 1 number'
                }
            ],
            userList: ['Captain America', 'Iron Man', 'Thor', 'Hulk'],
            radioOptions: ['Male', 'Female'],
            selectOptions: [
                {
                    label: 'Superman',
                    value: 'superman'
                },
                {
                    label: 'Batman',
                    value: 'batman'
                },
                {
                    label: 'Flash',
                    value: 'flash'
                },
                {
                    label: 'Wonder Woman',
                    value: 'wonderwoman'
                },
                {
                    label: 'Aquaman',
                    value: 'aquaman'
                }
            ],
            selectValue: 'batman',
            selectInputOptions: [
                {
                    label: 'Black Panther',
                    value: 'blackpanther'
                },
                {
                    label: 'Scarlet Witch',
                    value: 'scarletwitch'
                },
                {
                    label: 'Vision',
                    value: 'vision'
                },
                {
                    label: 'Spider-man',
                    value: 'spiderman'
                },
                {
                    label: 'Doctor Strange',
                    value: 'doctorstrange'
                },
                {
                    label: 'Falcon',
                    value: 'falcon'
                },
                {
                    label: 'Winter Soldier',
                    value: 'wintersoldier'
                },
                {
                    label: 'Black Widow',
                    value: 'blackwidow'
                },
                {
                    label: 'Hawkeye',
                    value: 'hawkeye'
                },
                {
                    label: 'War Machine',
                    value: 'warmachine'
                }
            ],
            avatarUrl: 'http://i62.tinypic.com/28bwsns.jpg',
            avatarName: 'Captain America',
            multiSelectTags: [],
            files: [
                {
                    src:
                        'https://farm6.staticflickr.com/5591/15008867125_b61960af01_h.jpg',
                    caption: '15008867125_b61960af01_h.jpg',
                    alt: '15008867125_b61960af01_h.jpg'
                },
                {
                    src:
                        'https://farm4.staticflickr.com/3902/14985871946_24f47d4b53_h.jpg',
                    caption: '14985871946_24f47d4b53_h.jpg',
                    alt: '14985871946_24f47d4b53_h.jpg'
                }
            ],
            galleryFiles: [
                {
                    src:
                        'https://farm6.staticflickr.com/5591/15008867125_b61960af01_h.jpg',
                    caption: '15008867125_b61960af01_h.jpg',
                    alt: '15008867125_b61960af01_h.jpg'
                },
                {
                    src:
                        'https://farm4.staticflickr.com/3902/14985871946_24f47d4b53_h.jpg',
                    caption: '14985871946_24f47d4b53_h.jpg',
                    alt: '14985871946_24f47d4b53_h.jpg'
                }
            ]
        };
    },
    created() {
        // console.log(this);
    },
    watch: {
        testPassword() {
            let validation = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/,
                characterValidation = /^[a-zA-Z\d]{8,}$/,
                uppercaseValidation = /^(?=.*[A-Z])[a-zA-Z\d]{1,}$/,
                numericValidation = /^(?=.*\d)[a-zA-Z\d]{1,}$/;

            if (characterValidation.test(this.testPassword)) {
                this.fieldCriteria[0].status = 'primary';
            } else {
                this.fieldCriteria[0].status = 'text';
            }

            if (uppercaseValidation.test(this.testPassword)) {
                this.fieldCriteria[1].status = 'primary';
            } else {
                this.fieldCriteria[1].status = 'text';
            }

            if (numericValidation.test(this.testPassword)) {
                this.fieldCriteria[2].status = 'primary';
            } else {
                this.fieldCriteria[2].status = 'text';
            }

            if (validation.test(this.testPassword)) {
                this.testPasswordType = 'is-primary';
            } else {
                this.testPasswordType = 'is-normal';
            }
        },
        testTextarea() {
            if (this.testTextarea) {
                this.testTextareaType = 'is-normal';
            }
        },
        selectAll(checked) {
            // select all items checked -> push items to array
            let items = [1, 2, 3, 4, 5];
            if (checked) {
                this.testCheckboxArr = [];
                this.testCheckboxArr = items;
            } else {
                this.testCheckboxArr = [];
            }
        }
    },
    computed: {
        // Do a check on component load of what validation rules should show on input focus
        // - Should not include special character message
        // As user types:
        // - Check if rule is valid.
        // - If password contains special character, show special character message

        // Check which validation messages should appear
        showValidationMessages() {
            return this.passwordValidation.passwordRules.filter(function(rule) {
                return rule.show;
            });
        },
        passwordValidation() {
            let passwordRules = this.rules;
            let valid = [];
            let isInputEmpty = this.checkPassword.length <= 0;

            if (!isInputEmpty) {
                for (let condition of passwordRules) {
                    // If contains special characters that are not allowed
                    if (condition.specialCharacters) {
                        // If entered allowed spectial characters
                        if (condition.regex.test(this.checkPassword)) {
                            condition.show = false;
                            condition.color = 'gray-10';
                        } else {
                            condition.show = true;
                            condition.color = 'red-30';
                        }
                    }
                    // The rest of the validation rules
                    else {
                        if (!condition.regex.test(this.checkPassword)) {
                            condition.color = 'gray-10';
                        } else {
                            condition.color = 'quore-green';
                        }
                    }
                }
            }
            return {
                valid: valid.length === 5,
                passwordRules
            };
        },
        passwordsFilled() {
            return this.checkPassword !== '' && this.passwordConfirm !== '';
        },
        samePasswords() {
            if (this.passwordsFilled) {
                return this.checkPassword === this.passwordConfirm;
            } else {
                return false;
            }
        }
    },
    methods: {
        onButtonClick() {
            alert('Button clicked');

            if (!this.testTextarea) {
                this.testTextareaType = 'is-danger';
            }
        },
        onPasswordFocus() {
            this.showPasswordHint = true;
        },
        onConfirmFocus() {
            this.showConfirmHint = true;
        },
        onPasswordBlur() {
            this.activePopover = false;
        }
    }
};
